import React from 'react'
import styled, { css } from 'styled-components'
import { array, string, bool } from 'prop-types'
import { rgba } from 'polished'

import { fontSizes, fontWeights } from 'styles/typography'
import { white, black } from 'styles/colors'
import { animationTime, animationCurve } from 'styles/global'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { ScrollConsumer } from 'components/ScrollContext'

const Container = styled.nav`
  position: fixed;
  left: 6%;
  top: 27.5%;
  z-index: 30;

  ${media.large`
    left: 7.5%;
  `};
`

const Item = styled.a`
  position: relative;
  display: block;
  transition: color ${animationTime} ${animationCurve}, transform ${animationTime} ${animationCurve};
  transform-origin: left center;
  color: ${props => (props.isDark ? rgba(white, 0.7) : rgba(black, 0.7))};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.medium};
  cursor: pointer;

  &:hover {
    color: ${props => (props.isDark ? white : black)};
  }

  &:before {
    content: '';
    position: absolute;
    left: -${spacing.medium};
    top: 3px;
    bottom: 3px;
    width: 2px;
    background-color: ${props => props.color};
    transition: opacity ${animationTime} ${animationCurve}, background-color ${animationTime} ${animationCurve};
    opacity: 0;
  }

  ${props =>
    props.active &&
    css`
      color: ${white};

      ${media.medium`
        color: ${props.color};
        font-weight: ${fontWeights.bold};
        transform: scale(1.2);

        &:hover {
          color: ${props.color};
        }
      `};

      &:before {
        opacity: 1;
      }
    `}

  & + & {
    margin-top: ${spacing.large};

    ${media.medium`
      margin-top: ${spacing.medium};
    `};
  }

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
    `}
`

const SlideshowMenu = ({ items, color, isDark }) => (
  <ScrollConsumer>
    {({ category, goToAnchor, handleCategoryChange }) => {
      return (
        <Container className="slideshow-menu">
          {items.map((item, i) => (
            <Item
              active={category === `#${item.anchor}`}
              onClick={() => {
                if (!item.disabled) {
                  goToAnchor(`#${item.anchor}`)
                  handleCategoryChange(`#${item.anchor}`)
                }
              }}
              isDark={isDark}
              color={color}
              key={i}
              disabled={item.disabled}
            >
              {item.label}
            </Item>
          ))}
        </Container>
      )
    }}
  </ScrollConsumer>
)

SlideshowMenu.propTypes = {
  items: array.isRequired,
  color: string.isRequired,
  isDark: bool
}

export default SlideshowMenu
